module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_styled_02-660e910a57514ea4a3a99d951254d3ab.png";